import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast, Toaster } from "sonner";
import { ArrowRight } from "@phosphor-icons/react";
import { GoogleSignInButton } from "./AuthCallback";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Password must be 6+ chars"); return; }
    setBusy(true);
    try {
      await register(name, email, password);
      toast.success("Account created");
      nav("/setup");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registration failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-2" style={{ background: "var(--bg)" }}>
      <Toaster theme="dark" />
      <div className="hidden md:block relative grid-bg border-r" style={{ borderColor: "var(--border)" }}>
        <div className="absolute inset-0 p-12 flex flex-col justify-between">
          <Link to="/" className="font-display font-black text-2xl tracking-tighter">
            MY NEXUS<span style={{ color: "var(--accent)" }}> </span>CARD
          </Link>
          <div>
            <div className="overline mb-3">// build your network</div>
            <h2 className="font-display font-black text-5xl tracking-tighter leading-none">
              Capture<br />the room.
            </h2>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="register-form">
          <div className="overline mb-4">// register</div>
          <h1 className="font-display font-black text-4xl tracking-tighter mb-10">Start free.</h1>

          <label className="label-base">Full name</label>
          <input data-testid="register-name" required value={name} onChange={(e) => setName(e.target.value)} className="input-base mb-6" />

          <label className="label-base">Email</label>
          <input data-testid="register-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-base mb-6" autoComplete="email" />

          <label className="label-base">Password</label>
          <input data-testid="register-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="input-base mb-8" autoComplete="new-password" />

          <button type="submit" disabled={busy} data-testid="register-submit" className="btn-primary w-full flex items-center justify-between">
            {busy ? "Creating..." : "Create account"} <ArrowRight weight="bold" />
          </button>

          <div className="my-6 flex items-center gap-3">
            <div className="flex-1 border-t" style={{ borderColor: "var(--border)" }}></div>
            <span className="overline">or</span>
            <div className="flex-1 border-t" style={{ borderColor: "var(--border)" }}></div>
          </div>
          <GoogleSignInButton testid="register-google" />

          <p className="mt-8 text-sm text-[#C7DDE5]">
            Have an account? <Link to="/login" className="text-white underline">Sign in</Link>
          </p>
          <p className="mt-6 text-xs" style={{ color: "var(--text-3)" }}>
            By creating an account you agree to our <Link to="/terms" className="underline" style={{ color: "var(--text-2)" }}>Terms</Link> and <Link to="/privacy" className="underline" style={{ color: "var(--text-2)" }}>Privacy Policy</Link>.
          </p>
        </form>
      </div>
    </div>
  );
}
